/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  HashId: { input: string; output: string; }
  Json: { input: any; output: any; }
};

export type Audit = {
  __typename?: 'Audit';
  auditId?: Maybe<Scalars['HashId']['output']>;
  createdOn: Scalars['String']['output'];
  lastUpdate: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  operationType: OperationTypeEnum;
  operatorId?: Maybe<Scalars['HashId']['output']>;
  operatorName: Scalars['String']['output'];
  tableName: Scalars['String']['output'];
  tablePrimaryKey: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type AuditEdge = {
  __typename?: 'AuditEdge';
  cursor: Scalars['String']['output'];
  node: Audit;
};

export type AuditFilterInput = {
  and?: InputMaybe<Array<AuditFilterInput>>;
  auditId?: InputMaybe<IdentityFilterInput>;
  createdOn?: InputMaybe<TextFilterInput>;
  lastUpdate?: InputMaybe<TextFilterInput>;
  newValue?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AuditFilterInput>;
  oldValue?: InputMaybe<StringFilterInput>;
  operationType?: InputMaybe<OperationTypeEnumFilterInput>;
  operatorId?: InputMaybe<IdentityFilterInput>;
  operatorName?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<AuditFilterInput>>;
  tableName?: InputMaybe<StringFilterInput>;
  tablePrimaryKey?: InputMaybe<StringFilterInput>;
};

export type AuditHavingInput = {
  user?: InputMaybe<UserFilterInput>;
};

export type AuditOrderInput = {
  auditId?: InputMaybe<OrderByEnum>;
  createdOn?: InputMaybe<OrderByEnum>;
  lastUpdate?: InputMaybe<OrderByEnum>;
  newValue?: InputMaybe<OrderByEnum>;
  oldValue?: InputMaybe<OrderByEnum>;
  operationType?: InputMaybe<OrderByEnum>;
  operatorId?: InputMaybe<OrderByEnum>;
  operatorName?: InputMaybe<OrderByEnum>;
  tableName?: InputMaybe<OrderByEnum>;
  tablePrimaryKey?: InputMaybe<OrderByEnum>;
};

export type AuditsConnection = {
  __typename?: 'AuditsConnection';
  edges: Array<AuditEdge>;
  nodes: Array<Audit>;
  pageInfo: PageInfo;
  paginationInfo?: Maybe<PaginationInfo>;
};

export type BooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  is_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  is_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Chat = {
  __typename?: 'Chat';
  chatId: Scalars['String']['output'];
  chatMessages: ChatMessagesConnection;
  createdOn?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['HashId']['output']>;
  isFinished: Scalars['Boolean']['output'];
  lastMessage?: Maybe<Scalars['String']['output']>;
  lastUpdate: Scalars['String']['output'];
  title: Scalars['String']['output'];
  user?: Maybe<User>;
};


export type ChatChatMessagesArgs = {
  filters?: InputMaybe<ChatMessageFilterInput>;
  orderBy?: InputMaybe<ChatMessageOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ChatBasic = {
  __typename?: 'ChatBasic';
  chatId: Scalars['String']['output'];
  createdOn?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['HashId']['output']>;
  isFinished: Scalars['Boolean']['output'];
  lastMessage?: Maybe<Scalars['String']['output']>;
  lastUpdate: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ChatEdge = {
  __typename?: 'ChatEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type ChatFilterInput = {
  and?: InputMaybe<Array<ChatFilterInput>>;
  chatId?: InputMaybe<TextFilterInput>;
  createdOn?: InputMaybe<TextFilterInput>;
  creatorId?: InputMaybe<IdentityFilterInput>;
  isFinished?: InputMaybe<BooleanFilterInput>;
  lastMessage?: InputMaybe<StringFilterInput>;
  lastUpdate?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<ChatFilterInput>;
  or?: InputMaybe<Array<ChatFilterInput>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ChatHavingInput = {
  chatMessage?: InputMaybe<ChatMessageFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

export type ChatInsertInput = {
  chatId: Scalars['String']['input'];
  createdOn?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['HashId']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  lastMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  chat?: Maybe<Chat>;
  chatId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdOn?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['HashId']['output']>;
  lastUpdate: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  role: RoleTypeEnum;
  user?: Maybe<User>;
};

export type ChatMessageEdge = {
  __typename?: 'ChatMessageEdge';
  cursor: Scalars['String']['output'];
  node: ChatMessage;
};

export type ChatMessageFilterInput = {
  and?: InputMaybe<Array<ChatMessageFilterInput>>;
  chatId?: InputMaybe<TextFilterInput>;
  content?: InputMaybe<StringFilterInput>;
  createdOn?: InputMaybe<TextFilterInput>;
  creatorId?: InputMaybe<IdentityFilterInput>;
  lastUpdate?: InputMaybe<TextFilterInput>;
  messageId?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<ChatMessageFilterInput>;
  or?: InputMaybe<Array<ChatMessageFilterInput>>;
  role?: InputMaybe<RoleTypeEnumFilterInput>;
};

export type ChatMessageHavingInput = {
  chat?: InputMaybe<ChatFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

export type ChatMessageOrderInput = {
  chatId?: InputMaybe<OrderByEnum>;
  content?: InputMaybe<OrderByEnum>;
  createdOn?: InputMaybe<OrderByEnum>;
  creatorId?: InputMaybe<OrderByEnum>;
  lastUpdate?: InputMaybe<OrderByEnum>;
  messageId?: InputMaybe<OrderByEnum>;
  role?: InputMaybe<OrderByEnum>;
};

export type ChatMessagesConnection = {
  __typename?: 'ChatMessagesConnection';
  edges: Array<ChatMessageEdge>;
  nodes: Array<ChatMessage>;
  pageInfo: PageInfo;
  paginationInfo?: Maybe<PaginationInfo>;
};

export type ChatOrderInput = {
  chatId?: InputMaybe<OrderByEnum>;
  createdOn?: InputMaybe<OrderByEnum>;
  creatorId?: InputMaybe<OrderByEnum>;
  isFinished?: InputMaybe<OrderByEnum>;
  lastMessage?: InputMaybe<OrderByEnum>;
  lastUpdate?: InputMaybe<OrderByEnum>;
  title?: InputMaybe<OrderByEnum>;
};

export type ChatUpdateInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['HashId']['input']>;
  isFinished?: InputMaybe<Scalars['Boolean']['input']>;
  lastMessage?: InputMaybe<Scalars['String']['input']>;
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ChatsConnection = {
  __typename?: 'ChatsConnection';
  edges: Array<ChatEdge>;
  nodes: Array<Chat>;
  pageInfo: PageInfo;
  paginationInfo?: Maybe<PaginationInfo>;
};

export type CreateUserParamsInput = {
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type CursorInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
};

export type DeleteUserParamsInput = {
  id: Scalars['String']['input'];
};

export type IdentityFilterInput = {
  between?: InputMaybe<Array<Scalars['HashId']['input']>>;
  eq?: InputMaybe<Scalars['HashId']['input']>;
  gt?: InputMaybe<Scalars['HashId']['input']>;
  gte?: InputMaybe<Scalars['HashId']['input']>;
  is_in?: InputMaybe<Array<Scalars['HashId']['input']>>;
  is_not_in?: InputMaybe<Array<Scalars['HashId']['input']>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['HashId']['input']>;
  lte?: InputMaybe<Scalars['HashId']['input']>;
  ne?: InputMaybe<Scalars['HashId']['input']>;
  not_between?: InputMaybe<Array<Scalars['HashId']['input']>>;
};

export type IntegerFilterInput = {
  between?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  is_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not_between?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilterInput = {
  eq?: InputMaybe<Scalars['Json']['input']>;
  ne?: InputMaybe<Scalars['Json']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _ping?: Maybe<Scalars['String']['output']>;
  chatCreateBatch: Array<ChatBasic>;
  chatCreateOne: ChatBasic;
  chatDelete: Scalars['Int']['output'];
  chatUpdate: Array<ChatBasic>;
  create_user: User;
  delete_user: Scalars['Boolean']['output'];
  pixelArtCreateBatch: Array<PixelArtBasic>;
  pixelArtCreateOne: PixelArtBasic;
  pixelArtDelete: Scalars['Int']['output'];
  pixelArtUpdate: Array<PixelArtBasic>;
  ratelimitPolicyCreateBatch: Array<RatelimitPolicyBasic>;
  ratelimitPolicyCreateOne: RatelimitPolicyBasic;
  ratelimitPolicyDelete: Scalars['Int']['output'];
  ratelimitPolicyUpdate: Array<RatelimitPolicyBasic>;
  update_user: User;
};


export type MutationChatCreateBatchArgs = {
  data: Array<ChatInsertInput>;
};


export type MutationChatCreateOneArgs = {
  data: ChatInsertInput;
};


export type MutationChatDeleteArgs = {
  filter?: InputMaybe<ChatFilterInput>;
};


export type MutationChatUpdateArgs = {
  data: ChatUpdateInput;
  filter?: InputMaybe<ChatFilterInput>;
};


export type MutationCreate_UserArgs = {
  params: CreateUserParamsInput;
};


export type MutationDelete_UserArgs = {
  params: DeleteUserParamsInput;
};


export type MutationPixelArtCreateBatchArgs = {
  data: Array<PixelArtInsertInput>;
};


export type MutationPixelArtCreateOneArgs = {
  data: PixelArtInsertInput;
};


export type MutationPixelArtDeleteArgs = {
  filter?: InputMaybe<PixelArtFilterInput>;
};


export type MutationPixelArtUpdateArgs = {
  data: PixelArtUpdateInput;
  filter?: InputMaybe<PixelArtFilterInput>;
};


export type MutationRatelimitPolicyCreateBatchArgs = {
  data: Array<RatelimitPolicyInsertInput>;
};


export type MutationRatelimitPolicyCreateOneArgs = {
  data: RatelimitPolicyInsertInput;
};


export type MutationRatelimitPolicyDeleteArgs = {
  filter?: InputMaybe<RatelimitPolicyFilterInput>;
};


export type MutationRatelimitPolicyUpdateArgs = {
  data: RatelimitPolicyUpdateInput;
  filter?: InputMaybe<RatelimitPolicyFilterInput>;
};


export type MutationUpdate_UserArgs = {
  params: UpdateUserParamsInput;
};

export type OffsetInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export enum OperationTypeEnum {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

export type OperationTypeEnumFilterInput = {
  eq?: InputMaybe<OperationTypeEnum>;
  gt?: InputMaybe<OperationTypeEnum>;
  gte?: InputMaybe<OperationTypeEnum>;
  is_in?: InputMaybe<Array<OperationTypeEnum>>;
  is_not_in?: InputMaybe<Array<OperationTypeEnum>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<OperationTypeEnum>;
  lte?: InputMaybe<OperationTypeEnum>;
  ne?: InputMaybe<OperationTypeEnum>;
};

export enum OrderByEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  current: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationInput = {
  cursor?: InputMaybe<CursorInput>;
  offset?: InputMaybe<OffsetInput>;
  page?: InputMaybe<PageInput>;
};

export enum PalleteNameEnum {
  Mard72 = 'mard72',
  Mard96 = 'mard96',
  Mard120 = 'mard120',
  Mard144 = 'mard144',
  Mard221 = 'mard221',
  Mard295 = 'mard295'
}

export type PalleteNameEnumFilterInput = {
  eq?: InputMaybe<PalleteNameEnum>;
  gt?: InputMaybe<PalleteNameEnum>;
  gte?: InputMaybe<PalleteNameEnum>;
  is_in?: InputMaybe<Array<PalleteNameEnum>>;
  is_not_in?: InputMaybe<Array<PalleteNameEnum>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<PalleteNameEnum>;
  lte?: InputMaybe<PalleteNameEnum>;
  ne?: InputMaybe<PalleteNameEnum>;
};

export type PixelArt = {
  __typename?: 'PixelArt';
  chat?: Maybe<Chat>;
  chatId: Scalars['String']['output'];
  createdOn: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastUpdate: Scalars['String']['output'];
  paletteName: PalleteNameEnum;
  patternGridJson?: Maybe<Scalars['Json']['output']>;
  patternImageUrl?: Maybe<Scalars['String']['output']>;
  patternLegendJson?: Maybe<Scalars['Json']['output']>;
  patternMetaJson?: Maybe<Scalars['Json']['output']>;
  pixelArtId?: Maybe<Scalars['HashId']['output']>;
  prompt: Scalars['String']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['HashId']['output']>;
  width: Scalars['Int']['output'];
};

export type PixelArtBasic = {
  __typename?: 'PixelArtBasic';
  chatId: Scalars['String']['output'];
  createdOn: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  lastUpdate: Scalars['String']['output'];
  paletteName: PalleteNameEnum;
  patternGridJson?: Maybe<Scalars['Json']['output']>;
  patternImageUrl?: Maybe<Scalars['String']['output']>;
  patternLegendJson?: Maybe<Scalars['Json']['output']>;
  patternMetaJson?: Maybe<Scalars['Json']['output']>;
  pixelArtId?: Maybe<Scalars['HashId']['output']>;
  prompt: Scalars['String']['output'];
  userId?: Maybe<Scalars['HashId']['output']>;
  width: Scalars['Int']['output'];
};

export type PixelArtEdge = {
  __typename?: 'PixelArtEdge';
  cursor: Scalars['String']['output'];
  node: PixelArt;
};

export type PixelArtFilterInput = {
  and?: InputMaybe<Array<PixelArtFilterInput>>;
  chatId?: InputMaybe<TextFilterInput>;
  createdOn?: InputMaybe<TextFilterInput>;
  errorMessage?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntegerFilterInput>;
  imageUrl?: InputMaybe<StringFilterInput>;
  lastUpdate?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<PixelArtFilterInput>;
  or?: InputMaybe<Array<PixelArtFilterInput>>;
  paletteName?: InputMaybe<PalleteNameEnumFilterInput>;
  patternGridJson?: InputMaybe<JsonFilterInput>;
  patternImageUrl?: InputMaybe<StringFilterInput>;
  patternLegendJson?: InputMaybe<JsonFilterInput>;
  patternMetaJson?: InputMaybe<JsonFilterInput>;
  pixelArtId?: InputMaybe<IdentityFilterInput>;
  prompt?: InputMaybe<StringFilterInput>;
  userId?: InputMaybe<IdentityFilterInput>;
  width?: InputMaybe<IntegerFilterInput>;
};

export type PixelArtHavingInput = {
  chat?: InputMaybe<ChatFilterInput>;
  user?: InputMaybe<UserFilterInput>;
};

export type PixelArtInsertInput = {
  chatId: Scalars['String']['input'];
  createdOn?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  paletteName: PalleteNameEnum;
  patternGridJson?: InputMaybe<Scalars['Json']['input']>;
  patternImageUrl?: InputMaybe<Scalars['String']['input']>;
  patternLegendJson?: InputMaybe<Scalars['Json']['input']>;
  patternMetaJson?: InputMaybe<Scalars['Json']['input']>;
  pixelArtId?: InputMaybe<Scalars['HashId']['input']>;
  prompt: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['HashId']['input']>;
  width: Scalars['Int']['input'];
};

export type PixelArtOrderInput = {
  chatId?: InputMaybe<OrderByEnum>;
  createdOn?: InputMaybe<OrderByEnum>;
  errorMessage?: InputMaybe<OrderByEnum>;
  height?: InputMaybe<OrderByEnum>;
  imageUrl?: InputMaybe<OrderByEnum>;
  lastUpdate?: InputMaybe<OrderByEnum>;
  paletteName?: InputMaybe<OrderByEnum>;
  patternGridJson?: InputMaybe<OrderByEnum>;
  patternImageUrl?: InputMaybe<OrderByEnum>;
  patternLegendJson?: InputMaybe<OrderByEnum>;
  patternMetaJson?: InputMaybe<OrderByEnum>;
  pixelArtId?: InputMaybe<OrderByEnum>;
  prompt?: InputMaybe<OrderByEnum>;
  userId?: InputMaybe<OrderByEnum>;
  width?: InputMaybe<OrderByEnum>;
};

export type PixelArtUpdateInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  paletteName?: InputMaybe<PalleteNameEnum>;
  patternGridJson?: InputMaybe<Scalars['Json']['input']>;
  patternImageUrl?: InputMaybe<Scalars['String']['input']>;
  patternLegendJson?: InputMaybe<Scalars['Json']['input']>;
  patternMetaJson?: InputMaybe<Scalars['Json']['input']>;
  pixelArtId?: InputMaybe<Scalars['HashId']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['HashId']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PixelArtsConnection = {
  __typename?: 'PixelArtsConnection';
  edges: Array<PixelArtEdge>;
  nodes: Array<PixelArt>;
  pageInfo: PageInfo;
  paginationInfo?: Maybe<PaginationInfo>;
};

export type Query = {
  __typename?: 'Query';
  audit?: Maybe<Audit>;
  audits: AuditsConnection;
  chat?: Maybe<Chat>;
  chatMessage?: Maybe<ChatMessage>;
  chatMessages: ChatMessagesConnection;
  chats: ChatsConnection;
  personal_user: User;
  pixelArt?: Maybe<PixelArt>;
  pixelArts: PixelArtsConnection;
  ratelimitPolicies: RatelimitPoliciesConnection;
  ratelimitPolicy?: Maybe<RatelimitPolicy>;
  user?: Maybe<User>;
  users: UsersConnection;
};


export type QueryAuditArgs = {
  id?: InputMaybe<Scalars['HashId']['input']>;
};


export type QueryAuditsArgs = {
  filters?: InputMaybe<AuditFilterInput>;
  having?: InputMaybe<AuditHavingInput>;
  orderBy?: InputMaybe<AuditOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryChatArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatMessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatMessagesArgs = {
  filters?: InputMaybe<ChatMessageFilterInput>;
  having?: InputMaybe<ChatMessageHavingInput>;
  orderBy?: InputMaybe<ChatMessageOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryChatsArgs = {
  filters?: InputMaybe<ChatFilterInput>;
  having?: InputMaybe<ChatHavingInput>;
  orderBy?: InputMaybe<ChatOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPixelArtArgs = {
  id?: InputMaybe<Scalars['HashId']['input']>;
};


export type QueryPixelArtsArgs = {
  filters?: InputMaybe<PixelArtFilterInput>;
  having?: InputMaybe<PixelArtHavingInput>;
  orderBy?: InputMaybe<PixelArtOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRatelimitPoliciesArgs = {
  filters?: InputMaybe<RatelimitPolicyFilterInput>;
  having?: InputMaybe<RatelimitPolicyHavingInput>;
  orderBy?: InputMaybe<RatelimitPolicyOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryRatelimitPolicyArgs = {
  id?: InputMaybe<Scalars['HashId']['input']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['HashId']['input']>;
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserFilterInput>;
  having?: InputMaybe<UserHavingInput>;
  orderBy?: InputMaybe<UserOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type RatelimitPoliciesConnection = {
  __typename?: 'RatelimitPoliciesConnection';
  edges: Array<RatelimitPolicyEdge>;
  nodes: Array<RatelimitPolicy>;
  pageInfo: PageInfo;
  paginationInfo?: Maybe<PaginationInfo>;
};

export type RatelimitPolicy = {
  __typename?: 'RatelimitPolicy';
  config: Scalars['Json']['output'];
  createdOn: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  lastUpdate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  policyId?: Maybe<Scalars['HashId']['output']>;
  policyType: Scalars['String']['output'];
};

export type RatelimitPolicyBasic = {
  __typename?: 'RatelimitPolicyBasic';
  config: Scalars['Json']['output'];
  createdOn: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  lastUpdate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  policyId?: Maybe<Scalars['HashId']['output']>;
  policyType: Scalars['String']['output'];
};

export type RatelimitPolicyEdge = {
  __typename?: 'RatelimitPolicyEdge';
  cursor: Scalars['String']['output'];
  node: RatelimitPolicy;
};

export type RatelimitPolicyFilterInput = {
  and?: InputMaybe<Array<RatelimitPolicyFilterInput>>;
  config?: InputMaybe<JsonFilterInput>;
  createdOn?: InputMaybe<TextFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  lastUpdate?: InputMaybe<TextFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RatelimitPolicyFilterInput>;
  or?: InputMaybe<Array<RatelimitPolicyFilterInput>>;
  policyId?: InputMaybe<IdentityFilterInput>;
  policyType?: InputMaybe<StringFilterInput>;
};

export type RatelimitPolicyHavingInput = {
  _?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatelimitPolicyInsertInput = {
  config: Scalars['Json']['input'];
  createdOn?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policyId?: InputMaybe<Scalars['HashId']['input']>;
  policyType: Scalars['String']['input'];
};

export type RatelimitPolicyOrderInput = {
  config?: InputMaybe<OrderByEnum>;
  createdOn?: InputMaybe<OrderByEnum>;
  enabled?: InputMaybe<OrderByEnum>;
  lastUpdate?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  policyId?: InputMaybe<OrderByEnum>;
  policyType?: InputMaybe<OrderByEnum>;
};

export type RatelimitPolicyUpdateInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  createdOn?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policyId?: InputMaybe<Scalars['HashId']['input']>;
  policyType?: InputMaybe<Scalars['String']['input']>;
};

export enum RoleTypeEnum {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

export type RoleTypeEnumFilterInput = {
  eq?: InputMaybe<RoleTypeEnum>;
  gt?: InputMaybe<RoleTypeEnum>;
  gte?: InputMaybe<RoleTypeEnum>;
  is_in?: InputMaybe<Array<RoleTypeEnum>>;
  is_not_in?: InputMaybe<Array<RoleTypeEnum>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<RoleTypeEnum>;
  lte?: InputMaybe<RoleTypeEnum>;
  ne?: InputMaybe<RoleTypeEnum>;
};

export type StringFilterInput = {
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  ci_eq?: InputMaybe<Scalars['String']['input']>;
  contains?: InputMaybe<Scalars['String']['input']>;
  ends_with?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  is_in?: InputMaybe<Array<Scalars['String']['input']>>;
  is_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  not_between?: InputMaybe<Array<Scalars['String']['input']>>;
  not_like?: InputMaybe<Scalars['String']['input']>;
  starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type TextFilterInput = {
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  is_in?: InputMaybe<Array<Scalars['String']['input']>>;
  is_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  not_between?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserParamsInput = {
  id: Scalars['String']['input'];
  is_valid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  chats: ChatsConnection;
  createdOn: Scalars['String']['output'];
  id?: Maybe<Scalars['HashId']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  lastIp?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastUpdate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
};


export type UserChatsArgs = {
  filters?: InputMaybe<ChatFilterInput>;
  orderBy?: InputMaybe<ChatOrderInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserFilterInput = {
  and?: InputMaybe<Array<UserFilterInput>>;
  createdOn?: InputMaybe<TextFilterInput>;
  id?: InputMaybe<IdentityFilterInput>;
  isAdmin?: InputMaybe<BooleanFilterInput>;
  isValid?: InputMaybe<BooleanFilterInput>;
  lastIp?: InputMaybe<StringFilterInput>;
  lastLogin?: InputMaybe<TextFilterInput>;
  lastUpdate?: InputMaybe<TextFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UserFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  password?: InputMaybe<StringFilterInput>;
};

export type UserHavingInput = {
  chat?: InputMaybe<ChatFilterInput>;
};

export type UserOrderInput = {
  createdOn?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  isAdmin?: InputMaybe<OrderByEnum>;
  isValid?: InputMaybe<OrderByEnum>;
  lastIp?: InputMaybe<OrderByEnum>;
  lastLogin?: InputMaybe<OrderByEnum>;
  lastUpdate?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  password?: InputMaybe<OrderByEnum>;
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UserEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
  paginationInfo?: Maybe<PaginationInfo>;
};

export type GetUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDetailsQuery = { __typename?: 'Query', personal_user: { __typename?: 'User', id?: string | null, createdOn: string, isValid: boolean, isAdmin: boolean, lastLogin?: string | null, lastUpdate: string, name: string } };

export type GetChatMessagesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  orderBy: ChatMessageOrderInput;
  filters: ChatMessageFilterInput;
}>;


export type GetChatMessagesQuery = { __typename?: 'Query', chatMessages: { __typename?: 'ChatMessagesConnection', nodes: Array<{ __typename?: 'ChatMessage', chatId: string, role: RoleTypeEnum, content: string, createdOn?: string | null }> } };

export type GetCurrentChatQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  orderBy: ChatOrderInput;
  filters: ChatFilterInput;
}>;


export type GetCurrentChatQuery = { __typename?: 'Query', chats: { __typename?: 'ChatsConnection', nodes: Array<{ __typename?: 'Chat', chatId: string, isFinished: boolean }> } };

export type GetAllPixelArtsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter: PixelArtFilterInput;
}>;


export type GetAllPixelArtsQuery = { __typename?: 'Query', pixelArts: { __typename?: 'PixelArtsConnection', nodes: Array<{ __typename?: 'PixelArt', pixelArtId?: string | null, userId?: string | null, paletteName: PalleteNameEnum, width: number, height: number, createdOn: string, patternImageUrl?: string | null, patternGridJson?: any | null, patternLegendJson?: any | null, patternMetaJson?: any | null, user?: { __typename?: 'User', id?: string | null, name: string } | null }>, paginationInfo?: { __typename?: 'PaginationInfo', total: number } | null } };

export type GetAdminAuditsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  orderBy: AuditOrderInput;
  filters: AuditFilterInput;
}>;


export type GetAdminAuditsQuery = { __typename?: 'Query', audits: { __typename?: 'AuditsConnection', nodes: Array<{ __typename?: 'Audit', auditId?: string | null, tableName: string, operationType: OperationTypeEnum, operatorName: string, createdOn: string }>, paginationInfo?: { __typename?: 'PaginationInfo', total: number } | null } };

export type GetAdminPixelArtsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filter: PixelArtFilterInput;
  having: PixelArtHavingInput;
}>;


export type GetAdminPixelArtsQuery = { __typename?: 'Query', pixelArts: { __typename?: 'PixelArtsConnection', nodes: Array<{ __typename?: 'PixelArt', pixelArtId?: string | null, userId?: string | null, paletteName: PalleteNameEnum, width: number, height: number, createdOn: string, patternImageUrl?: string | null, patternGridJson?: any | null, patternLegendJson?: any | null, patternMetaJson?: any | null, user?: { __typename?: 'User', id?: string | null, name: string } | null }>, paginationInfo?: { __typename?: 'PaginationInfo', total: number } | null } };

export type GetUsersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  orderBy: UserOrderInput;
  filters: UserFilterInput;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id?: string | null, name: string, isValid: boolean, createdOn: string }>, paginationInfo?: { __typename?: 'PaginationInfo', total: number } | null } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserParamsInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', create_user: { __typename?: 'User', id?: string | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  valid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', update_user: { __typename?: 'User', id?: string | null } };

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserParamsInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', delete_user: boolean };


export const GetUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personal_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const GetChatMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatMessageOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatMessageFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]}}]} as unknown as DocumentNode<GetChatMessagesQuery, GetChatMessagesQueryVariables>;
export const GetCurrentChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatId"}},{"kind":"Field","name":{"kind":"Name","value":"isFinished"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentChatQuery, GetCurrentChatQueryVariables>;
export const GetAllPixelArtsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPixelArts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PixelArtFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelArts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdOn"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelArtId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"paletteName"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"patternImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"patternGridJson"}},{"kind":"Field","name":{"kind":"Name","value":"patternLegendJson"}},{"kind":"Field","name":{"kind":"Name","value":"patternMetaJson"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllPixelArtsQuery, GetAllPixelArtsQueryVariables>;
export const GetAdminAuditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminAudits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditId"}},{"kind":"Field","name":{"kind":"Name","value":"tableName"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"operatorName"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdminAuditsQuery, GetAdminAuditsQueryVariables>;
export const GetAdminPixelArtsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminPixelArts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PixelArtFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"having"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PixelArtHavingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelArts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"having"},"value":{"kind":"Variable","name":{"kind":"Name","value":"having"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pixelArtId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"paletteName"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"patternImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"patternGridJson"}},{"kind":"Field","name":{"kind":"Name","value":"patternLegendJson"}},{"kind":"Field","name":{"kind":"Name","value":"patternMetaJson"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdminPixelArtsQuery, GetAdminPixelArtsQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserParamsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"valid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_valid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"valid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserParamsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;